import paramTypes from "./paramTypes";

const urlParams = {
    paidSearch: {
        key: "ps",
        type: paramTypes.QUERY_PARAM
    },
    campaignId: {
        key: "OCID",
        type: paramTypes.QUERY_PARAM
    },
    icId: {
        key: "icid",
        type: paramTypes.QUERY_PARAM
    }
};

export default urlParams;